import * as React from "react";
import type { SVGProps } from "react";
const SvgClockBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.519 12c0 5.302-4.3 9.6-9.602 9.6-5.304 0-9.603-4.298-9.603-9.6s4.3-9.6 9.603-9.6a9.6 9.6 0 0 1 8.317 4.8m-1.35 5.853 2.401-2.4 2.401 2.4m-8.172 1.565-3.6-1.2V8.4"
    />
  </svg>
);
export default SvgClockBackward;
